<template>
  <v-tooltip top :disabled="!disabled">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" class="align-self-start" style="height: 100%; min-height: 32px;">
        <v-tab v-show="!hide" :disabled="disabled" :to="to" style="height: 100%;">
          <v-icon v-text="icon" size="18" class="pr-2" />
          <p class="mb-0 smallertext">{{ text }}</p>
        </v-tab>
      </div>
    </template>
    <span>{{ disabledHint ? disabledHint : 'Tab disabled' }}</span>
  </v-tooltip>
</template>


<script>
export default {
  name: "SubMenuTab_Template",
  props: {
    to: Object,
    icon: String,
    text: String,
    hide: Boolean,
    disabled: Boolean,
    disabledHint: String
  },
  components: {
  },

  data() {
    return {
    };
  },

  mounted() {
  },

  methods: {

  },

  computed: {

  },

  watch: {
  },
};
</script>


<style lang='scss'></style>